module.exports = __webpack_public_path__ + "img/menu4.0b1234c8.png";